import * as AlertDialog from "@radix-ui/react-alert-dialog";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { loading } from "../../../../components/loading";
import { useState } from "react";

export function CouponModal({ open, setOpen, applyCodeClick, isLoading }) {
  const [code, setCode] = useState(false);

  const handleContinue = () => {
    applyCodeClick(code);
  };

  return (
    <AlertDialog.Root open={open}>
      <AlertDialog.Portal>
        <AlertDialog.Overlay className="fixed inset-0 bg-gray-300 opacity-50" />
        <AlertDialog.Content
          className={`fixed left-[50%] top-[50%] max-h-[95vh] w-full translate-x-[-50%] translate-y-[-50%] overflow-auto rounded-lg bg-pink-100 py-6 shadow-xl focus:outline-none data-[state=open]:animate-contentShow  md:max-w-xl`}
        >
          <div className="flex h-[75vh] flex-col">
            <div className="pb-6 pr-6">
              <XMarkIcon
                className="float-right h-9 w-9 cursor-pointer text-rasapink"
                onClick={() => setOpen(false)}
              />
            </div>
            <AlertDialog.Title className="mt-8 px-10 font-serif text-xl">
              Coupon code
            </AlertDialog.Title>
            <AlertDialog.Description className="mb-8 px-6 text-xl">
              <section id="form">
                <form>
                  <div className="container mx-auto mb-16 mt-10 flex max-w-3xl flex-col px-4">
                    <div className="relative mt-2 rounded-md shadow-sm">
                      <input
                        type="text"
                        className="block w-full rounded-md border-0 py-4 text-gray-900 shadow-sm ring-1 ring-inset
                  ring-gray-500 placeholder:text-gray-400 focus:ring-1 focus:ring-inset focus:ring-gray-500 sm:text-sm sm:leading-6"
                        onChange={(e) => setCode(e.target.value)}
                      />
                    </div>
                    <div className="flex flex-col justify-center">
                      <button
                        onClick={handleContinue}
                        type="button"
                        className="my-6 w-full rounded-full bg-rasapink px-24 py-4 text-sm font-semibold text-white hover:shadow-xl"
                      >
                        {isLoading ? loading : "apply code"}
                      </button>
                      <button
                        onClick={() => setOpen(false)}
                        type="button"
                        className="w-full rounded-full bg-white px-24 py-4 text-sm font-semibold text-gray-900 shadow-sm ring-2 ring-inset ring-rasapink hover:shadow-xl"
                      >
                        cancel
                      </button>
                    </div>
                  </div>
                </form>
              </section>
            </AlertDialog.Description>
          </div>
        </AlertDialog.Content>
      </AlertDialog.Portal>
    </AlertDialog.Root>
  );
}
